/* eslint-disable no-console */
import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

export const insertDPPLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DPP.DPP_ADD_LIBRARY}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDPPLibraryById = async (dppId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DPP.GET_DPP_BY_ID}/${dppId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllDPPLibrary = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DPP.GET_DPP_LIST}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editDPPLibraryById = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DPP.UPDATE_DPP_BY_ID}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleId = async (moduleId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}/${moduleId}/${pageId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCustomModuleLibrary = async (ids) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}`, {
      data: { libIds: ids },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const insertCustomModuleGroup = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleGroup = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleGroupId = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editCustomModuleGroupById = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCustomModuleGroup = async (ids) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, {
      data: { groupIds: ids },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addLibraryToCustomModuleGroup = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateCustomModuleLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.DUPLICATE_CUSTOM_MODULE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportExcelService = async () => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.CUSTOM_MODULE.DOWNLOAD_CUSTOM_TABLE_SAMPLE}`, null, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const activeInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_STATUS}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadDPPImageS3 = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DPP.UPLOAD_DPP_IMAGE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCMImageFromS3 = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CM_IMAGE_DELETE}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getNewPageId = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.GET_NEW_PAGEID}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCustomModuleLibraryPage = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_MODULE.DELETE_PAGE_ID}`, {
      data: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleList = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_LIST}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateLibraryPageSequence = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGE_REARRANGE}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleContentPage = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_CONTENT_PAGE}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// pageId Controls
export const getPageControls = async (customModuleLibId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGE_CONTROLS}/${customModuleLibId}/${pageId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
// pageId Controls
export const getSrcPages = async (customModuleLibId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGES}/${customModuleLibId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// get all depenednt controls
export const getDependentControlsList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_DEPENDENT_CONTROLS}/${data}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleContentData = async (moduleId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_CONTENT_DATA}/${moduleId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMetaDataURL = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DPP.FETCH_META_DATA}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteDPPLibrary = async (ids) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DPP.DELETE_DPP_LIBRARY}`, {
      dppIds: ids,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDPPProductById = async (devOrderId, dppId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DPP.GET_PRODUCT_DPP_BY_ID}${devOrderId}/${dppId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addDPPProductById = async (devOrderId, dppLibId, moduleData) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DPP.ADD_PRODUCT_DPP}${devOrderId}/${dppLibId}`, { ...moduleData });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadProductDPPImageS3 = async (data, devOrderId, devLibId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DPP.UPLOAD_IMAGE_TO_S3}/${devOrderId}/${devLibId}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGoogleMapDetails = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.GOOGLE_MAP_API.FETCH_MAP_LAT_LAG}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getGoogleMapPlaceAutocomplete = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.GOOGLE_MAP_API.GOOGLE_MAP_PLACES_AUTOCOMPLETE}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGoogleMapPlaceDetails = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.GOOGLE_MAP_API.GOOGLE_MAP_PLACES_DETAILS}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGoogleMapPlaceNearby = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.GOOGLE_MAP_API.GOOGLE_MAP_PLACES_NEARBY}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductDetails = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.FETCH_PRODUCT_LIST.GET}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getALLFactoryDetails = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COMPONENT_SUPPLIER.GET_MULTIPLE_SUPPLIER_DATA}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductBOM = async (devOrderId, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_FETCH_REFERENCE_SUPPLIER.GET_PRODUCT_DPP_bom}/${devOrderId}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const refreshDppControl = async (devOrderId, dppLibId) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DPP.REFRESH_DPP_CONTROL}/${devOrderId}/${dppLibId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const refreshControlPlusValue = async (devOrderId, dppLibId) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DPP.REFRESH_CONTROL_PLUS_VALUE}/${devOrderId}/${dppLibId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
